import {
  createContact,
  CreateContactMutation,
  CreateContactMutationVariables,
  deleteContact,
  DeleteContactMutation,
  DeleteContactMutationVariables,
  graphqlCall,
  updateContact,
  UpdateContactMutation,
  UpdateContactMutationVariables,
} from '@akin-home/amplify';

export const updateContactMutation = (params: UpdateContactMutationVariables) =>
  graphqlCall<UpdateContactMutation>(updateContact, params);

export const createContactMutation = (params: CreateContactMutationVariables) =>
  graphqlCall<CreateContactMutation>(createContact, params);

export const deleteContactMutation = (params: DeleteContactMutationVariables) =>
  graphqlCall<DeleteContactMutation>(deleteContact, params);
